import React from 'react'
import '../styles/layout/Home.css'
import { Container } from 'react-bootstrap';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';

const MissionVisionValue = () => {
  return (
    <section className="visionMissionValue section section--defer section--soft section--divide">
      <span className="aurora aurora--violet aurora--low" aria-hidden="true" />
      <span className="section__photo section__photo--mvv" data-parallax aria-hidden="true" />
      <Container>
        <div className="mvvGrid">
          <article className="card-x reveal">
            <span className="chip" aria-hidden="true">
              <VisibilityOutlinedIcon />
            </span>
            <h2 className="card-x__title">Vision</h2>
            <p className="card-x__text">To be the first choice for banks in their quest to build, operate and
              manage a profitable credit card business that delivers a seamless and
              delightful digital customer experience.
            </p>
          </article>

          <article className="card-x reveal" data-delay="1">
            <span className="chip" aria-hidden="true">
              <RocketLaunchOutlinedIcon />
            </span>
            <h2 className="card-x__title">Mission</h2>
            <p className="card-x__text">To work with our partner banks using future technology, robust processes and well-trained
              personnel to ensure timely, accurate, compliant and cost-effective solutions that not only
              meet our client’s needs but also go well beyond their expectations.
            </p>
          </article>

          <article className="card-x reveal" data-delay="2">
            <span className="chip" aria-hidden="true">
              <WorkspacePremiumOutlinedIcon />
            </span>
            <h2 className="card-x__title">Values</h2>
            <ul className="valueList">
              <li>Responsibility</li>
              <li>Reliability</li>
              <li>Transparency</li>
              <li>Accountability</li>
              <li>Fairness</li>
            </ul>
          </article>
        </div>
      </Container>
    </section>
  )
}

export default MissionVisionValue
